/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import {CombinesObjectModels} from '@tunnel-models/index';
import {CameraByIdLoadedReducer, CameraBySectionLoadedReducer, CameraCreatedReducer, CameraInhibitionsLoadedReducer, CameraLapiTmdLoadedReducer, CameraLoadedReducer, CameraRemoveReducer, CameraSettingLoadedReducer, CameraSettingReducer, CameraSwitchSegmentedReducer, CameraSwitchSegmentedResetReducer, CameraUpdateReducer, CameraUpdateZoneReducer, ChangePassWordReducer, CheckCameraZoneMaskReducer, CheckIncidentsIsNotQualifyReducer, CheckNewIncidentsReducer, CitilogIncidentExtractedReducer, CitilogIncidentLoadedReducer, DashboardLoadedReducer, DisplayParamVideoLoadedReducer, DisplayParamVideoReducer, EmailForgetPassWordReducer, ExploreExtractIncidentReducer, ExploreLoadedReducer, ExportCameraCSVLoadedReducer, ExtractorCameraListReducer, ExtractorPdfIncidentReducer, ExtractorVideoReducer, ExtrairePdfTmdReducer, FilterIncidentTmdReducer, GetAllZoneForMaskLoadedReducer, GetCameraBeforeAndAfterByLocationReducer, GetZoneByIdCameraLoadedReducer, ImpactIsQualifiedReducer, ImpactSettingReducer, IncidentInhibateGlobalLoadedReducer, IncidentInhibateLocalCreatedReducer, IncidentInhibateLocalLoadedReducer, IncidentInhibateLocalRemoveReducer, IncidentInhibateReducer, IncidentRulesReducer, IncidentstmdLoadedReducer, IncidentTypesLoadedReducer, InhibitionByCameraLoadedReducer, LapiAndTmpLoadedReducer, LoginReducer, LogoutReducer, ModalInhibitionsLoadedReducer, ModalInhibitionsUpdatedReducer, NewPassWordReducer, NotificationLoadedReducer, ParametersDisplayLoadedReducer, ParametersDisplayUpdatedReducer, ProgressBarReducer, QualificationIncidentTmdReducer, ReplayDownloadReducer, ReplayReducer, SearchIncidentByIdReducer, SearchlapiTmdIncidentReducer, SectionSaveZoneReducer, SectionSettingsReducer, SectionSwitchSegmentedResetReducer, SectionZonesLoadedReducer, SetSectionSettingsReducer, SimulatorReducer, StatsByCameraLoadedReducer, SystemSettingsReducer, TunnelWatchCameraLoadedReducer, TunnelWatchOneCameraLoadedReducer, UserAuthorizationLoadReducer, UserRightLoadReducer, UsersCreatedReducer, UsersLoadedReducer, UsersRemovedReducer, UsersUpdatedReducer, VersionningReducer,

} from '@tunnel-store/index';
import {routerReducer} from 'react-router-redux';
import {combineReducers, Reducer} from 'redux';

/**
 * CombineReducers - regroupe l'ensemble des reduceurs de l'app
 * @function CombineReducers
 * @return { Reducer<CombinesObjectModels<any>> }
 *
 */

export const CombineReducers: Reducer<CombinesObjectModels<any>> =
    combineReducers<CombinesObjectModels<any>>({

      CameraByIdLoaded: CameraByIdLoadedReducer,
      CameraBySection: CameraBySectionLoadedReducer,
      CameraCreated: CameraCreatedReducer,
      CameraInhibitionsLoaded: CameraInhibitionsLoadedReducer,
      CameraLoaded: CameraLoadedReducer,
      CameraLapiTmdLoaded: CameraLapiTmdLoadedReducer,
      CameraRemove: CameraRemoveReducer,
      CameraSetting: CameraSettingReducer,
      CameraSettingLoaded: CameraSettingLoadedReducer,
      CameraSwitchSegmented: CameraSwitchSegmentedReducer,
      CameraSwitchSegmentedReset: CameraSwitchSegmentedResetReducer,
      CameraUpdate: CameraUpdateReducer,
      CameraUpdateZone: CameraUpdateZoneReducer,
      ChangePassWord: ChangePassWordReducer,
      CheckCameraZoneMask: CheckCameraZoneMaskReducer,
      CheckNewIncidents: CheckNewIncidentsReducer,
      CheckIncidentsIsNotQualify: CheckIncidentsIsNotQualifyReducer,
      CitilogIncidentExtracted: CitilogIncidentExtractedReducer,
      CitilogIncidentLoaded: CitilogIncidentLoadedReducer,
      DashboardLoaded: DashboardLoadedReducer,
      EmailForgetPassWord: EmailForgetPassWordReducer,
      ExploreExtractIncident: ExploreExtractIncidentReducer,
      ExploreLoaded: ExploreLoadedReducer,
      ExportCameraCSVLoaded: ExportCameraCSVLoadedReducer,
      ExtractorCameraList: ExtractorCameraListReducer,
      ExtractorPdfIncident: ExtractorPdfIncidentReducer,
      ExtractorVideo: ExtractorVideoReducer,
      ExtrairePdfTmd: ExtrairePdfTmdReducer,
      FilterIncidentTmd: FilterIncidentTmdReducer,
      GetAllZoneForMaskLoaded: GetAllZoneForMaskLoadedReducer,
      GetCameraBeforeAndAfterByLocation:
          GetCameraBeforeAndAfterByLocationReducer,
      GetZoneByIdCameraLoaded: GetZoneByIdCameraLoadedReducer,
      ImpactIsQualified: ImpactIsQualifiedReducer,
      ImpactSetting: ImpactSettingReducer,
      IncidentInhibate: IncidentInhibateReducer,
      IncidentInhibateGlobalLoaded: IncidentInhibateGlobalLoadedReducer,
      IncidentInhibateLocalCreated: IncidentInhibateLocalCreatedReducer,
      IncidentInhibateLocalLoaded: IncidentInhibateLocalLoadedReducer,
      IncidentInhibateLocalRemove: IncidentInhibateLocalRemoveReducer,
      IncidentRules: IncidentRulesReducer,
      IncidentstmdLoaded: IncidentstmdLoadedReducer,
      IncidentTypesLoaded: IncidentTypesLoadedReducer,
      InhibitionByCameraLoaded: InhibitionByCameraLoadedReducer,
      LapiAndTmpLoaded: LapiAndTmpLoadedReducer,
      Login: LoginReducer,
      Logout: LogoutReducer,
      ModalInhibitionsLoaded: ModalInhibitionsLoadedReducer,
      ModalInhibitionsUpdated: ModalInhibitionsUpdatedReducer,
      NewPassWord: NewPassWordReducer,
      NotificationLoaded: NotificationLoadedReducer,
      DisplayParamVideo: DisplayParamVideoReducer,
      DisplayParamVideoLoaded: DisplayParamVideoLoadedReducer,
      ParametersDisplayLoaded: ParametersDisplayLoadedReducer,
      ParametersDisplayUpdated: ParametersDisplayUpdatedReducer,
      ProgressBar: ProgressBarReducer,
      QualificationIncidentTmd: QualificationIncidentTmdReducer,
      ReplayDownload: ReplayDownloadReducer,
      Replay: ReplayReducer,
      Router: routerReducer,
      SearchIncidentById: SearchIncidentByIdReducer,
      SearchlapiTmdIncident: SearchlapiTmdIncidentReducer,
      SectionSaveZone: SectionSaveZoneReducer,
      SectionSettings: SectionSettingsReducer,
      SectionSwitchSegmentedReset: SectionSwitchSegmentedResetReducer,
      SectionZonesLoaded: SectionZonesLoadedReducer,
      SetSectionSettings: SetSectionSettingsReducer,
      Simulator: SimulatorReducer,
      StatsByCameraLoaded: StatsByCameraLoadedReducer,
      SystemSettings: SystemSettingsReducer,

      TunnelWatchCameraLoaded: TunnelWatchCameraLoadedReducer,
      TunnelWatchOneCameraLoaded: TunnelWatchOneCameraLoadedReducer,
      UsersLoaded: UsersLoadedReducer,
      UsersCreated: UsersCreatedReducer,
      UsersRemoved: UsersRemovedReducer,
      UsersUpdated: UsersUpdatedReducer,
      UserAuthorizationLoad: UserAuthorizationLoadReducer,
      Versionning: VersionningReducer,
      UserRightLoad: UserRightLoadReducer

    })


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/combineReducers/index.ts